export default __webpack_public_path__ + "static/media/tutorial-icon.5f473322.svg";